<div class="chat-input-container">

  @if(showTeamSizeWarning){
    <div class="teamSizeWarning">
      <p class="teamSizeWarning-text">
      {{ __('userAmountWarning') }}
      </p>

    </div>
  }

  <ng-container *ngIf="errorOccurred">
    <div class="chat-message-error">
      <div class="error-icon-wrapper">
        <img src="assets/icons/chatbot/ChatErrorMessageIcon.svg" alt="error icon"/>
      </div>
      <span class="error-message-wrapper">
        {{ errorMessage }}
      </span>
    </div>
  </ng-container>

  <div class="chat-input-vertical-container">
    <div class="chat-input-box">
      @if(isMeshModeAvailable){
        <div class="mesh-mode">
          <clr-dropdown>
            <button class="mesh-mode-search-button" clrDropdownTrigger
                    (click)="OnAtButtonClick()">
              @if(!hasActiveProfiles()){
                &#64; Person • Team
              } @else {
                &#64;
              }
            </button>
            <clr-dropdown-menu class="mesh-mode-dropdown-menu"
                               clrPosition="top-left"
                               clrCloseMenuOnItemClick="true"
                               *clrIfOpen>
              <clr-dropdown>
                <button class="mesh-mode-dropdown-menu-item" clrDropdownTrigger>
                  <clr-icon shape="user"></clr-icon>
                  {{ __('person') }}
                </button>
                <clr-dropdown-menu class="mesh-mode-dropdown-menu second-level-result-list" clrPosition="top-left" *clrIfOpen>
                  <div class="mesh-mode-second-dropdown-container">
                    <button class="mesh-mode-dropdown-menu-item back-button" clrDropdownItem>
                      <clr-icon shape="angle"></clr-icon>
                      {{ __('myContacts') }}
                    </button>
                    <button class="mesh-mode-dropdown-menu-item" *ngFor="let profile of availableProfiles"
                            (click)="addNewProfile(profile)" clrDropdownItem>
                      <clr-icon shape="user"></clr-icon>
                      <div class="mesh-mode-dropdown-menu-item-name">
                        {{ profile.firstName }} {{ profile.lastName }}
                      </div>
                    </button>
                    @if(availableProfiles.length < numberOfAvailableProfiles && !isLoadingAvailableProfiles){
                      <button class="mesh-mode-dropdown-menu-item load-more-button" (click)="loadMoreProfiles()">
                        {{ __('loadMore') }}
                      </button>
                    }
                    @if(isLoadingAvailableProfiles){
                      <button class="mesh-mode-dropdown-menu-item load-more-button">
                        {{ __('loading') }}
                      </button>
                    }
                  </div>
                </clr-dropdown-menu>
              </clr-dropdown>
              <clr-dropdown>
                <button class="mesh-mode-dropdown-menu-item" clrDropdownTrigger>
                  <clr-icon shape="users"></clr-icon>
                  {{ __('team') }}
                </button>
                <clr-dropdown-menu class="mesh-mode-dropdown-menu second-level-result-list" clrPosition="top-left" *clrIfOpen>
                  <div class="mesh-mode-second-dropdown-container">
                    <button class="mesh-mode-dropdown-menu-item back-button" clrDropdownItem>
                      <clr-icon shape="angle"></clr-icon>
                      {{ __('myTeams') }}
                    </button>
                    <button class="mesh-mode-dropdown-menu-item" *ngFor="let team of availableTeams"
                            (click)="addNewTeam(team)" clrDropdownItem>
                      <clr-icon shape="users"></clr-icon>
                      <div class="mesh-mode-dropdown-menu-item-name">
                        {{ team.teamName }}
                      </div>
                      <div class="mesh-mode-dropdown-menu-item-size">
                         {{ team.teamSize }} {{ __('members') }}
                      </div>
                    </button>
                    @if(availableTeams.length < numberOfAvailableTeams && !isLoadingAvailableTeams){
                      <button class="mesh-mode-dropdown-menu-item load-more-button" (click)="loadMoreTeams()">
                        {{ __('loadMore') }}
                      </button>
                    }
                    @if(isLoadingAvailableTeams){
                      <button class="mesh-mode-dropdown-menu-item load-more-button">
                        {{ __('loading') }}
                      </button>
                    }
                  </div>
                </clr-dropdown-menu>
              </clr-dropdown>
            </clr-dropdown-menu>
          </clr-dropdown>
          @if(hasActiveProfiles()){
            <div class="mesh-mode-container">
              <div class="mesh-mode-profiles">
              @if(!isMobile){
                <button class="mesh-mode-profile-name"
                        *ngFor="let profile of activeProfiles()"
                        (click)="addProfileToMessage(profile)">
                  @if(profile.status != 'DELETED'){
                    {{ profile.firstName }} {{ profile.lastName }}
                  }
                </button>
              } @else {
                <button class="mesh-mode-profile-name"
                        *ngFor="let profile of activeProfiles()"
                        (click)="addProfileToMessage(profile)">
                  @if(profile.status != 'DELETED'){
                    {{ profile.firstName.slice(0, 1) }}{{ profile.lastName.slice(0, 1) }}
                  }
                </button>
              }
              </div>
              <button class="remove-profiles-button" (click)="removeProfiles()">
                <clr-icon shape="times"></clr-icon>
              </button>
            </div>
          }
        </div>
      }
      <div class="input-row">
        <div class="input">
          <!--suppress HtmlFormInputWithoutLabel -->
          <textarea autosize [maxRows]="10"
                    [minRows]="1"
                    (focusin)="inputFocused = true"
                    (focusout)="inputFocused = false"
                    [(ngModel)]="message"
                    (input)="onInput()"
                    #messageInput
                    placeholder="{{__('inputPlaceholder')}}">
          </textarea>

          <!-- Mention Overlay positioned relative to the input -->
          <app-mention-overlay
            *ngIf="showMentionOverlay"
            [users]="mentionResults"
            [defaultUsers]="mentionDefaultProfiles"
            [defaultTeams]="mentionDefaultTeams"
            [position]="mentionPosition"
            [activeIndex]="mentionActiveIndex"
            (userSelected)="insertMention($event)"
            (defaultTeamSelected)="addNewTeam($event)"
            (activeIndexChanged)="updateActiveIndex($event)">
          </app-mention-overlay>
        </div>

        <div class="actions" *ngIf=" !isChatbotActive()">
          <div class="send" [class.active]="!isMessageEmpty()">
            <div class="img-wrapper">
              <img (click)="send()" alt="send message: inactive, please enter a message"
                   src="assets/icons/ID37_Chatbot_IconSend_Filled.svg"/>
            </div>
          </div>
        </div>
        <div class="stop-button" *ngIf="isChatbotActive()">
          <img (click)="stopChatbot()" alt="stop chatbot"
               src="assets/icons/stop-button.svg"/>
        </div>
      </div>
    </div>
  </div>
  <div class="chat-input-disclaimer">
    <p class="first-disclaimer">{{ __('inputDisclaimer1') }}</p>
    <p class="second-disclaimer" [innerHTML]="__('inputDisclaimer2')">{{ __('inputDisclaimer2')}}</p>
  </div>
</div>

<app-chatbot-chat-create-admin-form [form]="adminForm" [(modalOpen)]="adminCreateFormOpen"
                                    (formSubmit)="newChatAdmin()"></app-chatbot-chat-create-admin-form>
